export default __webpack_public_path__ + "static/media/file_upload.a549e3c6.svg";